<div fxLayout="row" fxLayoutGap="15px">
  <div fxFlex='70%'>
    <h1 mat-dialog-title>
      Add Contractor
    </h1>
  </div>
  <div fxFlex='30%'>
    <a href="javascript:void(0)" (click)="onClickClose()" style="color: #8f8f8f">
      <mat-icon style="size: 18px; float: right !important;">close</mat-icon>
    </a>
  </div>
</div>

<div ngStyle.gt-sm="{'width':'800px'}" ngStyle.lt-md="{'width':'98%'}" style="min-height: 70%;">
  <mat-vertical-stepper [linear]="disableLinear" #stepper>
    <mat-step [stepControl]="formLicense">
      <form [formGroup]="formLicense">
        <ng-template matStepLabel>
          Lookup your contractor {{contractorLicenseSummary}}
        </ng-template>

        <p>
          You must have a valid license number for the contractor.
        </p>
        <div>
          <mat-form-field
            appearance="outline"
            style="width: 200px;">
            <mat-label>License Number</mat-label>
            <input matInput autocomplete="off"
              maxlength=100
              placeholder="License Number"
              id="contractorLicenseNumber"
              name="contractorLicenseNumber"
              formControlName="contractorLicenseNumber"
              trim="blur">
              <mat-error
                *ngIf="onCheckFormLicenseControlValidators('contractorLicenseNumber')">
                License required
              </mat-error>

              <!-- <mat-hint *ngIf="invalidLicense">
                <span style="color: red">{{invalidLicenseClassificationMsg}}</span>
              </mat-hint> -->
          </mat-form-field>
        </div>
 <div *ngIf="invalidLicense"><span class="warn-text">{{invalidLicenseClassificationMsg}}</span></div>
        <div>
          <div>
            <button mat-stroked-button color="primary"
              (click)="onLookupLicenseNumber()">
              LOOKUP CONTRACTOR
            </button>
          </div>
        </div>
        <div *ngIf="iscontractorexists">

          <div fxLayout="row" fxLayout.lt-md="column wrap" *ngIf="isExistcontractorData">
               <div fxFlex='50%'>
              <div style="margin-top: 12px;" [ngStyle.lt-md]="{'margin-left': '9px'}">
                <div
                    matTooltip="{{isExistcontractorData.businessName}}"
                    class="business-name"
                  >
                    {{ isExistcontractorData.businessName }}
                  </div>
                  <div style="font-size: 12px;">
                    {{ isExistcontractorData.address2_Line1 }}, {{ isExistcontractorData.address2_Line2 ? isExistcontractorData.address2_Line2 + ',' : '' }} {{ isExistcontractorData.address2_City }}, {{ isExistcontractorData.address2_StateOrProvince }}
                    {{ isExistcontractorData.address2_PostalCode }}
                  </div>
                  <div style="font-size: 12px;">
                    (License #:
                    <span
                      *ngIf="
                        isExistcontractorData.contractorLicenseNumber &&
                        isExistcontractorData.contractorLicenseNumber.length > 0;
                        else: licenseNoUnavailable
                      "
                    >
                      {{ isExistcontractorData.contractorLicenseNumber }})
                    </span>
                    <ng-template #licenseNoUnavailable>
                      <span>Unavailable)</span>
                    </ng-template>
                  </div>
               
              </div>
            </div>
            <div fxFlex='50%'>
              <div style="margin-top: 12px;" [ngStyle.lt-md]="{'margin-left': '9px'}">
                <div style="font-size: 12px;">
                  Email: {{isExistcontractorData.emailAddress1}}
                </div>
                <div style="font-size: 12px;">
                  Phone:
                    <span
                      *ngIf="isExistcontractorData.address2_Telephone1 && isExistcontractorData.address2_Telephone1.length > 0 else phoneUnavailable">
                      {{isExistcontractorData.address2_Telephone1}}
                    </span>
                    <ng-template #phoneUnavailable>
                      <span>Unavailable</span>
                    </ng-template>
                </div>
                <div style="font-size: 12px;">
                  Web:
                  <span *ngIf="isExistcontractorData.webSiteUrl && isExistcontractorData.webSiteUrl.length > 0;  else: websiteUnavailable">
                    <a target="_blank" rel="noopener" href="{{formatLink(isExistcontractorData.webSiteUrl)}}">
                      {{formatLink(isExistcontractorData.webSiteUrl)}}</a>
                  </span>
                  <ng-template #websiteUnavailable>
                    <span>Unavailable</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
      
          <P><b>Your contractor already exists in our system</b></P>

          <button mat-stroked-button color="primary"
          (click)="onExistingContractorSelect()">
          SELECT CONTRACTOR
        </button>
        </div>
        <div *ngIf="invalidLicenseClassification">
          <p>{{invalidLicenseClassificationMsg}}Message</p>
        </div>

        <div *ngIf="contractorCoData  && !iscontractorexists"
          style="margin: 12px 0 12px 9px; ">
          <span *ngIf="contractorCoData.name && contractorCoData.name.length > 0">
            {{contractorCoData.name}}
          </span>
          <div>
            <span *ngIf="contractorCoData.addr1 && contractorCoData.addr1.length > 0">
              {{contractorCoData.addr1}} {{contractorCoData.addr2}}
            </span>
            <span *ngIf="contractorCoData.addr1 && contractorCoData.addr1.length > 0">
              {{contractorCoData.city}}, {{contractorCoData.state}} {{contractorCoData.zip}}
            </span>
            <div>
              <span *ngIf="contractorCoData.addr1 && contractorCoData.addr1.length > 0">
                License classification: {{contractorData.classifications}}
              </span>
            </div>
            <div>
              <span *ngIf="contractorCoData.addr1 && contractorCoData.addr1.length > 0">
                License expiration: {{displayLicenseExpiration()}}
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="invalidLicenseClassification">
          Only contractors with license classifications of A or B can be used for retrofits.
        </div>

        <div *ngIf="checkLicense" style="margin-top: 12px; margin-bottom: 12px;">
          <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
        </div>

        <div style="margin-top: 21px;">
          <button mat-stroked-button matStepperNext color="primary"
            [disabled]="this.disableNext1" >
            CONTINUE
          </button>
        </div>

      </form>
    </mat-step>
    <mat-step [stepControl]="formContact"  *ngIf="licensecheckdone" >
      <form [formGroup]="formContact" >
        <ng-template matStepLabel>Provide contractor details {{contractorContactInfoSummary}}</ng-template>

        <div>
          <mat-form-field
            appearance="outline"
            style="width: 200px;">
            <mat-label>First Name</mat-label>
            <input matInput autocomplete="off"
              maxlength=100
              placeholder="First name"
              id="firstName"
              name="firstName"
              formControlName="firstName"
              trim="blur" required>
            <mat-error
              *ngIf="onCheckFormContactControlValidators('firstName')">
              First name required
            </mat-error>
            <mat-hint *ngIf="onCheckFormContactControlLengthHint('firstName', 100)">
              100 character limit
            </mat-hint>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            style="width: 200px;">
            <mat-label>Last Name</mat-label>
            <input matInput autocomplete="off"
              maxlength=100
              placeholder="Last name"
              id="lastName"
              name="lastName"
              formControlName="lastName"
              trim="blur" required>
            <mat-error
              *ngIf="onCheckFormContactControlValidators('lastName')">
              Last name required
            </mat-error>
            <mat-hint *ngIf="onCheckFormContactControlLengthHint('lastName', 100)">
              100 character limit
            </mat-hint>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field
            appearance="outline"
            style="width: 150px;">
            <mat-label>Phone</mat-label>
            <input matInput autocomplete="off"
              placeholder="Phone"
              mask="(000) 000-0000"
              id="telephone1"
              name="telephone1"
              formControlName="telephone1"
              trim="blur" required >
            <mat-error
              *ngIf="onCheckFormContactControlValidators('telephone1')">
              Phone required
            </mat-error>
          </mat-form-field>

          <mat-form-field
            appearance="outline"
            style="width: 250px;">
            <mat-label>Email</mat-label>
            <input matInput autocomplete="off"
              type="email"
              placeholder="Email address"
              id="emailAddress2"
              name="emailAddress2"
              formControlName="emailAddress2"
              trim="blur" required>
            <mat-error
              *ngIf="onCheckFormContactControlValidators('emailAddress2')">
              Valid email required
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-checkbox style="margin-left: 3px; font-size: 14px;"
            id="verifyinsuredbonded"
            name="verifyinsuredbonded"
            formControlName="verifyinsuredbonded" required>
            * I verify that contractor is bonded and insured.
          </mat-checkbox>

       
        </div>

        <div style="margin-top: 21px;">
          <button mat-button matStepperPrevious>
            BACK
          </button>
          <button mat-stroked-button matStepperNext color="primary"
            (click)="setContractorContactInfoSummary()"
            [disabled]="(formContact.pristine || formContact.invalid)" >
            CONTINUE
          </button>
        </div>

      </form>
    </mat-step>
    <mat-step *ngIf="licensecheckdone" >
      <form [formGroup]="formMailing">
        <ng-template matStepLabel>Contractor mailing address {{contractMailingAddressSummary}}</ng-template>

        <div>
          <mat-checkbox style="margin-left: 3px; font-size: 14px;"
          id="sameAsBusinessAddress"
          name="sameAsBusinessAddress"
          formControlName="sameAsBusinessAddress"
          (change)="onCheckSameAsBusinessAddress($event)">
            Mailing address is same as business address.
        </mat-checkbox>
        </div>
        <div style="margin-top: 6px;">
          <div>
            <mat-form-field
              appearance="outline"
              style="width: 300px; max-width:100%;">
              <mat-label>Street Address</mat-label>
              <input matInput autocomplete="off"
                maxlength=250
                placeholder="Street Address"
                id="address3_Line1"
                name="address3_Line1"
                formControlName="address3_Line1"
                trim="blur" required>
                <mat-error
                  *ngIf="onCheckFormMailingControlValidators('address3_Line1')">
                  Street address required
                </mat-error>
                <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_Line1', 250)">
                  250 character limit
                </mat-hint>
            </mat-form-field>
          </div><div>
            <mat-form-field
            appearance="outline"
            style="width: 300px; max-width:100%;">
            <mat-label>Street Address Line 2</mat-label>
            <input matInput autocomplete="off"
              maxlength=250
              placeholder="Street Address Line 2"
              id="address3_Line2"
              name="address3_Line2"
              formControlName="address3_Line2"
              trim="blur">
              <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_Line2', 250)">
                250 character limit
              </mat-hint>
          </mat-form-field>
          </div><div>
            <mat-form-field
              appearance="outline"
              style="width: 125px;">
              <mat-label>City</mat-label>
                <input matInput autocomplete="off"
                  maxlength=80
                  placeholder="City"
                  id="address3_City"
                  name="address3_City"
                  formControlName="address3_City"
                  trim="blur" required>
                <mat-error
                  *ngIf="onCheckFormMailingControlValidators('address3_City')">
                  City required
                </mat-error>
                <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_City', 80)">
                  80 character limit
                </mat-hint>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="width: 75px;">
              <mat-label>State</mat-label>
              <input matInput autocomplete="off"
                maxlength=50
                placeholder="State"
                id="address3_StateOrProvince"
                name="address3_StateOrProvince"
                formControlName="address3_StateOrProvince"
                trim="blur" required>
              <mat-error
                *ngIf="onCheckFormMailingControlValidators('address3_StateOrProvince')">
                State required
              </mat-error>
              <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_StateOrProvince', 50)">
                50 character limit
              </mat-hint>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="width: 75px;">
              <mat-label>ZIP</mat-label>
              <input matInput autocomplete="off"
                maxlength=20
                placeholder="ZIP Code"
                id="address3_PostalCode"
                name="address3_PostalCode"
                formControlName="address3_PostalCode"
                trim="blur" required>
                <mat-error
                  *ngIf="onCheckFormMailingControlValidators('address3_PostalCode')">
                  ZIP Code required
              </mat-error>
              <mat-hint *ngIf="onCheckFormMailingControlLengthHint('address3_PostalCode', 20)">
                20 character limit
              </mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div style="margin-top: 21px;">
          <button mat-button matStepperPrevious>BACK</button>
          <button mat-flat-button color="primary"
            [disabled]="disableSave ||
                        (formContact.pristine || formContact.invalid) ||
                        (formMailing.pristine || formMailing.invalid)"
            (click)="onSave()">
            SAVE
          </button>
        </div>
      </form>
    </mat-step>
  </mat-vertical-stepper>
</div>
